<template>
  <div id="app">
    <div class="app-wrap">
      <router-view v-if="ready" />
      <Icons />
      <Satelite />
    </div>
  </div>
</template>

<script>
import "./assets/sass/styles.scss";
import Icons from "./assets/svg/Icons";
import Satelite from "@/components/shared/Satelite";
import axios from "axios";

export default {
  data() {
    return {
      ready: false,
      country: undefined,
      lang: undefined
    };
  },
  components: {
    Icons,
    Satelite
  },
  created() {
    this.addHeadDTM();
  },

  async mounted() {
    await this.setDataForCountry();
  },

  methods: {
    addHeadDTM() {
      let dtmHead = document.createElement("script");
      dtmHead.setAttribute(
        "src",
        "//assets.adobedtm.com/c4286b4b2b34cb9b097fac1cfe0e4ac48afd27e3/satelliteLib-51de92fd2e4ae3ed809182cf705f44f30dffe9ed-staging.js"
      );
      document.head.appendChild(dtmHead);
    },
    async setDataForCountry() {
      await this.getCountryAndLang();
      await this.getTxt();
    },
    async getCountryAndLang() {
      this.country = this.$route.params.country;
      this.lang = this.$route.params.lang;

      if (!this.lang) {
        // No need to set default version using API since it just setup lang && country
        const defaultValues = require(`@/assets/data/i18n/default.json`);
        this.country = defaultValues.defaultCountry;
        this.lang = defaultValues.defaultLanguage;
      }
      this.$store.commit("SET_COUNTRY", this.country);
      this.$store.commit("SET_LANG", this.lang);
    },
    async getEnvVariables() {
      // check if user is a developer on local
      if (process.env.VUE_APP_AXIOS === "local") {
        return require(`@/assets/data/vehicles/ariya/tools/range_calculator/countries/${this.country}/${this.lang}.json`);
      }
      let txtdata = await axios.get(`/data/vehicles/ariya/tools/range_calculator/countries/${this.country}/${this.lang}.json`);
      return txtdata.data;
    },
    async getTxt() {
      const txt = await this.getEnvVariables();
      this.$store.commit("SET_TXT", txt);
      return (this.ready = true);
    }
  }
};
</script>


